import { RootState } from "src/shared/types/src";

export const selectNurserySettingsLoading = (state: RootState) =>
    state?.nurserySetting?.settingLoading;

export const selectNurserySettings = (state: RootState) =>
    state?.nurserySetting?.settings;

export const selectFeaturesEnabled = (state: RootState) =>
    state?.nurserySetting?.settings?.featuresEnabled;

export const canDownloadFilePermission = (state: RootState) =>
    state?.nurserySetting?.settings?.canDownloadFiles;

export const canViewAssessmentsPermission = (state: RootState) =>
    state?.nurserySetting?.settings?.canViewAssessments || false;

export const canViewMedicineFormsSelector = (state: RootState) =>
    state?.nurserySetting?.settings?.canViewMedicineForms || false;

export const canSignInOutSelector = (state: RootState) =>
    state?.nurserySetting?.settings?.canSignInOut || false;

export const canReportAbsenceSelector = (state: RootState) =>
    state?.nurserySetting?.settings?.canReportAbsence || false;
